import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
const columns = [
  {
    dataField: 'srNo',
    text: 'Sr No',
    editable: false,
    sort: true,
  },
  {
    dataField: 'name',
    text: 'Name',
    sort: true,
    editable: false,
  },
  {
    dataField: 'createdAt',
    text: 'Created At',
    editable: false,
    sort: true,
  },
  {
    dataField: 'updatedAt',
    text: 'Updated At',
    editable: false,
    sort: true,
  },
  {
    dataField: 'actions',
    text: 'Actions',
    editable: false,
    sort: true,
  },
];
export const DistrictsList = (props) => {
  const handleCellChange = (prevVal, currentVal, row) => {
    props.onUpdate(row.id, { name: currentVal });
  };

  return (
    <div className='table-responsive'>
      <BootstrapTable
        keyField='srNo'
        data={props.data || []}
        columns={columns}
        cellEdit={cellEditFactory({
          mode: 'dbclick',
          afterSaveCell: handleCellChange,
        })}
      />
    </div>
  );
};
